module.exports = __webpack_public_path__ + "static/media/4.844d3226.png";